// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGInsertImage = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M24.593 11.153c.223 0 .436.042.619.116l-.002-.002.012.005c.617.256 1.051.864 1.051 1.574v9.153c0 .946-.768 1.714-1.714 1.714H7.402c-.946 0-1.714-.768-1.714-1.714 0-.383.126-.736.335-1.017l3.863-4.572.003-.004c.264-.354.664-.598 1.13-.657l.01-.002-.01.002s.001 0 0 0c.086-.014.174-.021.263-.021.398 0 .764.137 1.05.362l3.428 3.772-.003-.001c.079.04.168.062.263.062.173 0 .33-.076.437-.197l6.857-8 .002-.001c.314-.351.77-.572 1.277-.572zM7.989 12.297c1.262 0 2.285-1.023 2.285-2.286 0-1.262-1.023-2.285-2.285-2.285-1.263 0-2.286 1.023-2.286 2.285 0 1.263 1.023 2.286 2.286 2.286z"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.154 2H26.87c2.832.013 5.123 2.31 5.13 5.143v17.18c-.026 2.824-2.323 5.106-5.154 5.106H5.13C2.298 29.416.007 27.12 0 24.286V7.142C.007 4.302 2.312 2 5.154 2zm21.703 24.034c.946 0 1.714-.768 1.714-1.714V7.143c0-.946-.768-1.714-1.714-1.714H5.13c-.94.006-1.701.771-1.701 1.714V24.32c0 .946.768 1.714 1.714 1.714h21.714z"
  })]
}));
SVGInsertImage.displayName = 'SVGInsertImage';
export default SVGInsertImage;